import type { ComponentProps } from 'react';
import { Pictogram } from '@cbhq/cds-web/illustrations/Pictogram';
import { VStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';

import { useLogErrorView } from './useLogErrorView';

type PictogramName = ComponentProps<typeof Pictogram>['name'];

type Props = {
  title?: string;
  description?: string;
  pictogramName?: PictogramName;
  align?: 'start' | 'center';
  error?: Error;
};

export function InAppErrorMessageFallback({
  title,
  align,
  description,
  pictogramName,
  error,
}: Props) {
  useLogErrorView('in_app_error_message_fallback', error?.message);

  return (
    <VStack alignItems="center" width="100%" paddingX={3} paddingY={10} height="100%">
      <VStack gap={2} alignItems={align} maxWidth={680}>
        {pictogramName != null && <Pictogram name={pictogramName} dimension="64x64" />}
        {title != null && (
          <Text as="h1" font="title1" textAlign="center">
            {title}
          </Text>
        )}
        {description != null && (
          <Text font="body" color="fgMuted" textAlign="center">
            {description}
          </Text>
        )}
      </VStack>
    </VStack>
  );
}
